import { useState } from "react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useSession } from "@/context/SessionContext";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { cn } from "@/lib/utils";

export const AppShell = ({ children }) => {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("g39.sidebar") === "1");
  const [mobileOpen, setMobileOpen] = useState(false);
  const { me, company } = useSession();
  const toggle = () => {
    localStorage.setItem("g39.sidebar", collapsed ? "0" : "1");
    setCollapsed(!collapsed);
  };
  return (
    <div className="min-h-screen flex">
      <aside className={cn("hidden lg:block fixed inset-y-0 left-0 z-40", collapsed ? "w-16" : "w-64")}>
        <Sidebar collapsed={collapsed} />
      </aside>
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="p-0 w-72 border-0 bg-white">
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <Sidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>
      <div className={cn("flex-1 min-w-0 bg-[hsl(var(--secondary)/0.5)] min-h-screen", collapsed ? "lg:pl-16" : "lg:pl-64")}>
        {(me?.environment === "preview" || company?.is_demo) && (
          <div className="g39-stripes border-b text-[11px] text-amber-900 px-4 sm:px-6 py-1.5" data-testid="environment-banner">
            {company?.is_demo
              ? "DEMO COMPANY — sample records for development and isolation testing only. Not live business data."
              : "Preview environment — data here is for development and testing."}
          </div>
        )}
        <Topbar collapsed={collapsed} onToggle={toggle} onMobileMenu={() => setMobileOpen(true)} />
        <main className="p-4 sm:p-6 lg:p-8 max-w-[1400px] mx-auto">{children}</main>
      </div>
    </div>
  );
};
